var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"BadgeList d-inline-flex flex-wrap",staticStyle:{"gap":"4px"}},_vm._l((_vm.items),function(i){return _c('b-badge',{key:i,attrs:{"pill":""}},[_vm._v(" "+_vm._s(i)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }